import type { CoreShellPorts } from '../../../../routing/domain/CoreShellPorts.ts';
import type { ShellAuthApplicationPort } from '../../../../app-context/domain/ports/ShellAuthApplicationPort.ts';
import type { ShellNavigationPort } from '../../../../app-context/domain/ports/ShellNavigationPort.ts';
import type { PresentationShellPort } from '../../../../presentation/application/ports/PresentationShellPort.ts';
import { requireAuth } from './shellRouteGuards.ts';
/** Create dashboard route. */


export function createDashboardRoute<T extends CoreShellPorts>(
  auth: ShellAuthApplicationPort,
  navigation: ShellNavigationPort,
  presentation: PresentationShellPort<T>,
  shellPorts: T,
): () => Promise<void> {
  return requireAuth(auth, navigation, presentation.createMainPageHandler('dashboard', shellPorts));
}
